module.exports = __webpack_public_path__ + "img/yh_flow.ac280c81.png";